import React from 'react';
import background from '../assets/images/bg-splash.svg';

const LoginPage: React.FC = () => {
  return (
    <div
      className="login bg-image text-white py-4 ff-roboto"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="container-fluid d-flex align-items-center justify-content-center h-100">
        <div className="row">
          <div className="col-lg-12 text-center login-brand mb-5">
            <img src={require('src/assets/images/logo.svg').default} alt="logo" />
          </div>
          
          <div className="col-lg-12 my-auto mb-2 text-center">
            You should be redirected to a login screen soon...
          </div>

          <div className="col-lg-12 my-auto mb-2 text-center">
            Please contact support in the case you do not get redirected within a few seconds.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
